export default __webpack_public_path__ + "assets/images/Payment_09.09d9bd.avif";